import { Add, Close, OpenInFullRounded } from '@mui/icons-material';
import { SparkMark } from './icons';

interface Props {
	onClose: () => void;
	onNewChat: () => void;
}

const ChatBotHeader = ({ onClose, onNewChat }: Props) => (
	<>
		<div className='chatBot--header'>
			<SparkMark size={34} />
			<div className='chatBot--hd-info'>
				<div className='chatBot--hd-name'>
							NovaForce
							<span className='chatBot--hd-beta'>Beta</span>
						</div>
				<div className='chatBot--hd-sub'>AI-powered ERP assistant</div>
			</div>
			<div className='chatBot--hd-actions'>
				<button title='New chat' onClick={onNewChat}>
					<Add style={{ fontSize: 18 }} />
				</button>
				<button title='Expand'>
					<OpenInFullRounded style={{ fontSize: 16 }} />
				</button>
				<button title='Close' onClick={onClose}>
					<Close style={{ fontSize: 18 }} />
				</button>
			</div>
		</div>

		<div className='chatBot--ctx-bar'>
			<span className='chatBot--ctx-chip'>
				<span className='chatBot--ctx-dot' />
				ERP Data
			</span>
			<span className='chatBot--ctx-label'>All modules · Live data</span>
		</div>
	</>
);

export default ChatBotHeader;
